import { create } from 'zustand'

import {
  InsightStore,
  LastTimeConfig,
  Prefix,
  Suffix,
  TimeConfig,
  WeekTimeConfig,
} from './types'
import {
  calculateWeekRange,
  getCurrentWeekNumber,
  calculateLastRange,
} from './utils'

export const useInsightStore = create<InsightStore>((set) => {
  // Initialize with default values
  const defaultSuffix = Suffix.Week
  const defaultRange = calculateLastRange(defaultSuffix)

  return {
    time: {
      prefix: Prefix.Last,
      suffix: defaultSuffix,
      range: defaultRange,
    } as TimeConfig,

    setPrefix: (prefix) =>
      set((state) => {
        if (prefix === Prefix.Week) {
          // When changing to 'week', set up a week number configuration
          const weekNumber = getCurrentWeekNumber()
          const range = calculateWeekRange(weekNumber)

          return {
            time: {
              prefix,
              weekNumber,
              range,
            } as WeekTimeConfig,
          }
        } else {
          // When changing to 'last', set up a last configuration
          const suffix = Suffix.Week // Default to Week
          const range = calculateLastRange(suffix)

          return {
            time: {
              prefix,
              suffix,
              range,
            } as LastTimeConfig,
          }
        }
      }),

    setSuffix: (suffix) =>
      set((state) => {
        // Only allow changing suffix when prefix is 'last'
        if (state.time.prefix === Prefix.Last) {
          const range = calculateLastRange(suffix)

          return {
            time: {
              ...state.time,
              suffix,
              range,
            } as LastTimeConfig,
          }
        }
        return state // No change if prefix is 'week'
      }),

    setWeekNumber: (weekNumber) =>
      set((state) => {
        // Only allow changing week number when prefix is 'week'
        if (state.time.prefix === Prefix.Week) {
          // Ensure week number is between 1-52
          const validWeekNumber = Math.min(Math.max(1, weekNumber), 52)
          const range = calculateWeekRange(validWeekNumber)

          return {
            time: {
              ...state.time,
              weekNumber: validWeekNumber,
              range,
            } as WeekTimeConfig,
          }
        }
        return state // No change if prefix is 'last'
      }),
  }
})
